import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { inject } from '@angular/core';

import { OrganizationDetailsService } from './organization-details.service';
import { AuthService } from 'src/app/core/services/auth.service';

@Component({
  selector: 'app-organization-details',
  templateUrl: './organization-details.component.html',
  styleUrls: ['./organization-details.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class OrganizationDetailsComponent implements OnInit {
  @Input() orgId: string | null = null;
  loading = false;
  error: string | null = null;
  org: any = null;

  private orgDetailsService = inject(OrganizationDetailsService);
  private authService = inject(AuthService);

  ngOnInit(): void {
    if (this.orgId) {
      this.fetchOrgDetails(this.orgId);
    }
  }

  fetchOrgDetails(orgId: string) {
    this.loading = true;
    const token = this.authService.token;
    this.orgDetailsService.getOrgDetails(orgId, token)
      .subscribe({
        next: (data) => {
          this.org = data;
          this.loading = false;
        },
        error: () => {
          this.error = 'Failed to load organization details.';
          this.loading = false;
        }
      });
  }
}
